export const knowledgeBaseData = [
    {
      id: 1,
      title: "Quick Questions are answered",
      knowledgeList: [
        {
          text: "Policies have wide acceptance among editors",
          fileTextIcon: true,
        },
        {
          text: "Guidelines are sets of best practices supported.",
          badge: "New",
          fileTextIcon: true,
        },
        {
          fileTextIcon: true,
          text: "Editors should attempt to follow guidelines.",
        },
        {
          fileTextIcon: true,
          text: "They are best treated with common sense.",
        },
        {
          text: "See More (40)",
        },
      ],
    },
    {
      id: 2,
      title: "API allows search and download AP Images.",
      knowledgeList: [
        {
          text: "API retrieve breaking news categories.",
          fileTextIcon: true,
          badge: "Review",
        },
        {
          fileTextIcon: true,
          text: "API retrieves rules for fantasy league.",
        },
        {
          fileTextIcon: true,
          text: "Resource API retrieves content business.",
          badge: "Articles",
        },
        {
          fileTextIcon: true,
          text: "Making this the first true generator on the Internet.",
        },
        {
          text: "See More (90)",
        },
      ],
    },
    {
      id: 3,
      title: "WordPress Site Maintenance",
      knowledgeList: [
        {
          fileTextIcon: true,
          text: "Make a backup of your WordPress website.",
        },
        {
          fileTextIcon: true,
          text: "Run a Wordpress security Website check.",
          badge: "Closed",
        },
        {
          fileTextIcon: true,
          text: "Monitor your search engine optimization.",
        },
        {
          fileTextIcon: true,
          text: "Set a regular maintenance schedule.",
        },
        {
          text: "See More (50)",
        },
      ],
    },
    {
      id: 4,
      title: "Meta Tags in WordPress",
      knowledgeList: [
        {
          text: "When an unknown printer took a galley",
          fileTextIcon: true,
          badge: "Popular",
        },
        {
          fileTextIcon: true,
          text: "You can easily change plans at any time.",
        },
        {
          fileTextIcon: true,
          text: "you’ll be charged a prorated cover that upgrade.",
        },
        {
          fileTextIcon: true,
          text: "But also the leap into electronic typesetting,",
        },
        {
          text: "See More (90)",
        },
      ],
    },
    {
      id: 5,
      title: "WordPress in Your Language",
      knowledgeList: [
        {
          text: "Premium plans are billed as a single yearly payment.",
          fileTextIcon: true,
        },
        {
          text: "Monthly plan are bill every month of signup.",
          fileTextIcon: true,
        },
        {
          text: "You can set Monthly or Yearly for Premium plan.",
          fileTextIcon: true,
        },
        {
          fileTextIcon: true,
          text: "unknown printer took galley.",
          badge: "Closed",
        },
        {
          text: "See More (50)",
        },
      ],
    },
    {
      id: 6,
      title: "Know Your Sources",
      knowledgeList: [
        {
          fileTextIcon: true,
          text: "Many new editors rely on policy interpretations.",
        },
        {
          fileTextIcon: true,
          text: "Editor continually attempts to find a different policy.",
        },
        {
          text: "Violation of maintaining a neutral point of view.",
          fileTextIcon: true,
          badge: "Article",
        },
        {
          fileTextIcon: true,
          text: "You double check your sources.",
        },
        {
          text: "See More (26)",
        },
      ],
    },
    {
      id: 7,
      title: "Validating a Website",
      knowledgeList: [
        {
          text: "You can modify some specific component settings.",
          fileTextIcon: true,
          badge: "Review",
        },
        {
          fileTextIcon: true,
          text: "Click Apply to validate the set preferences.",
        },
        {
          text: "Following procedure apply the components",
          fileTextIcon: true,
          badge: "Closed",
        },
        {
          fileTextIcon: true,
          text: " To modify those specific components settings.",
        },
        {
          text: "See More (10)",
        },
      ],
    },
    {
      id: 8,
      title: "Quick Questions are answered",
      knowledgeList: [
        {
          fileTextIcon: true,
          text: "To get started with your account.",
        },
        {
          text: "Click Apply to validate the set preferences.",
          fileTextIcon: true,
          badge: "Popular",
        },
        {
          text: "Users can browse by topic or use the visually.",
          fileTextIcon: true,
          badge: "Review",
        },
        {
          text: "This works through various methods of site tracking",
          fileTextIcon: true,
        },
        {
          text: "See More (21)",
        },
      ],
    },
    {
      id: 9,
      title: "Integrating WordPress with Your Website",
      knowledgeList: [
        {
          text: "Language regular existing languages.",
          fileTextIcon: true,
        },
        {
          text: "The first line of Lorem Ipsum,  Lorem ipsum",
          fileTextIcon: true,
        },
        {
          text: "Thus comes from a line in section",
          fileTextIcon: true,
        },
        {
          text: "First true generator on the Internet",
          badge: "On hold",
          fileTextIcon: true,
        },
        {
          text: "See More (34)",
        },
      ],
    },
  ];
